import { sendEnvsToWorker } from '@next-box/envs';
import { useEffect, useState } from 'react';

export const useWorker = () => {
  const [worker, setWorker] = useState<Worker>();

  useEffect(() => {
    const w = new Worker(new URL('worker.ts', import.meta.url));
    sendEnvsToWorker(w);
    setWorker(w);

    return () => {
      w.terminate();
    };
  }, []);

  return worker;
};
